/**
 * Returns the inspector device IANA timezone used for factory visit session day boundaries.
 */
export function getInspectorTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
